import React from 'react';
import { Typography } from '@mui/material';
import LegalPage from '../../components/LegalPage/LegalPage';

const Terms = () => (
    <LegalPage product="LiftLog" title="Terms &amp; Conditions">
        <p><strong>Effective Date:</strong> March 22, 2026</p>
        <p>By using LiftLog, you agree to the following terms:</p>

        <Typography variant="h6">1. Use of Service</Typography>
        <p>
            LiftLog is provided for personal fitness tracking purposes only.
        </p>

        <Typography variant="h6">2. User Accounts</Typography>
        <p>
            You are responsible for maintaining the confidentiality of your account.
        </p>

        <Typography variant="h6">3. Health Disclaimer</Typography>
        <p>
            LiftLog does not provide medical advice. Always consult a professional before starting any fitness program.
        </p>

        <Typography variant="h6">4. Subscription &amp; Payments</Typography>
        <ul>
            <li>Payments are handled through Apple App Store or Google Play</li>
            <li>Subscriptions renew automatically unless canceled</li>
        </ul>

        <Typography variant="h6">5. Data &amp; Content</Typography>
        <p>
            You retain ownership of your data, but grant us permission to store and process it for app functionality.
        </p>

        <Typography variant="h6">6. Termination</Typography>
        <p>
            We may suspend or terminate accounts for misuse or abuse.
        </p>

        <Typography variant="h6">7. Limitation of Liability</Typography>
        <p>
            We are not liable for injuries, damages, or losses resulting from use of the app.
        </p>

        <Typography variant="h6">8. Changes to Terms</Typography>
        <p>
            We may update these terms at any time.
        </p>

        <Typography variant="h6">9. Contact</Typography>
        <p>Email: evolvedevlabs@gmail.com</p>
    </LegalPage>
);

export default Terms;
